import { SVGProps } from 'react';

/** Filled quotation mark, the solid version of `QuoteOutlineIcon`. Uses `currentColor`. */
export const QuoteMarksIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      viewBox="0 0 174 143"
      fill="currentColor"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M78 3.5C86.5604 3.5 93.5 10.4396 93.5 19V78.1807C93.5 81.3431 92.5323 84.4296 90.7275 87.0264L60.0469 131.169C52.0855 143.45 33.1507 133.778 38.4902 120.101L47.8994 96C49.8817 90.9228 46.137 85.4414 40.6865 85.4414H19C10.4397 85.4414 3.50013 78.5017 3.5 69.9414V19C3.5 10.4396 10.4396 3.5 19 3.5H78Z"
        strokeWidth="7"
      />
      <path
        d="M154.8 2C165.293 2 173.8 10.5066 173.8 21V80.1807C173.8 84.0572 172.614 87.8412 170.401 91.0244L139.739 135.141C129.466 150.853 105.165 138.411 112.03 120.827L121.439 96.7275C122.526 93.9453 120.473 90.9414 117.486 90.9414H111.052C112.203 87.4915 112.8 83.8595 112.8 80.1807V21C112.8 13.9626 110.662 7.4245 107 2H154.8ZM123.121 85.4443C123.077 85.4188 123.033 85.3941 122.988 85.3691C123.033 85.394 123.077 85.4189 123.121 85.4443ZM122.8 85.2656C122.746 85.2368 122.692 85.2086 122.638 85.1807C122.692 85.2087 122.746 85.2368 122.8 85.2656ZM122.442 85.082C122.393 85.058 122.344 85.0341 122.295 85.0107C122.344 85.0341 122.393 85.058 122.442 85.082Z"
        stroke="none"
      />
    </svg>
  );
};
